// extracted by mini-css-extract-plugin
module.exports = {"nhg":"verbouwing-verbetering-modal_nhg__2cZn0"};